export default {
    setFeatureEnabled(state, value) {
        state.isFeatureEnabled = value
    }
}